import ForgotUsername from './ForgotUsernameContainer';

export default ForgotUsername;



// WEBPACK FOOTER //
// ./src/components/pages/User/SignIn/components/ForgotUsername/index.js